"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var useHeaderHeight_native_exports = {};
__export(useHeaderHeight_native_exports, {
  useHeaderHeight: () => useHeaderHeight
});
module.exports = __toCommonJS(useHeaderHeight_native_exports);
var import_elements = require("@react-navigation/elements");
var import_react = require("react");
function useHeaderHeight() {
  var _useContext;
  return (_useContext = (0, import_react.useContext)(import_elements.HeaderHeightContext)) !== null && _useContext !== void 0 ? _useContext : 0;
}
//# sourceMappingURL=useHeaderHeight.native.js.map
